
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getNotInDeptUserList, getDeptUserList, batchDelDeptUser } from '@/api/company';
import { timeoutUserLists, timeoutUser } from '@/api/system';
import { setUserDept, setUserRole, getRoleUserList, getNoRoleUserList, batchDelRoleUser, authUserList } from '@/api/users';
import { UserModule } from '../../store/modules/user';
@Component({
  name: 'SetStaff',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogSetStaffVisible!: Boolean;
  @Prop({
    type: String,
    default: ''
  })
  paramsStr!: String;
  @Prop({
    type: Number,
    default: 0
  })
  typeEnter!: Number;
   private title='';
  // 1 添加部门人员 2 删除部门人员 3 添加角色人员 4 删除角色人员  5 提醒人员设定
  private listQuery:{
    name: string,
  } = {
    name: ''
  };
  private selectedDynamicTags:any=[]
  private customHeight = window.innerHeight * 0.4;
  created() {
    this.getList();
  }
  // 列表
  private tableList = [];
  private page = 1;
  private loadMore=false;

  cancleDialogHandle() {
    this.$emit('close', false);
  }
  finishDialogHandle() {
    this.conform();
  }
  // 搜索
  private search() {
    this.getList();
  }
  // 搜索清楚
  private restSearch() {
    this.listQuery = {
      name: ''
    };
    this.getList();
  }
  // 加载更多
  private moreData() {
    this.page = this.page + 1;
    this.getList();
  }
  // 获取列表
  private getList() {
    // 人员不再部门内
    switch (this.typeEnter) {
      case 1:
        this.title = '添加人员';
        this.getNotInDeptUserList();
        break;
      case 2:
        this.title = '删除人员';
        this.getDeptUserList();
        break;
      case 3:
        this.title = '添加人员';
        this.getNoRoleUserList();
        break;
      case 4:
        this.title = '删除人员';
        this.getRoleUserList();
        break;
      case 5:
        this.title = '提醒人员设定';
        this.authUserList(1);
        break;
      case 6:
        this.title = '限制人员设定';
        this.authUserList(2);
        break;
    }
  }
  // 确认 按钮
  private conform() {
    //6需要可以设置为空
    if(!(this.typeEnter==6 || this.typeEnter==5) ){
      if (this.selectedDynamicTags.length < 1 ) {
        return;
      }
    }
    switch (this.typeEnter) {
      case 1:
        this.setDeptUserList(this.selectedDynamicTags);
        break;
      case 2:
        this.delDeptUserList(this.selectedDynamicTags);
        break;
      case 3:
        this.setRoleUserList(this.selectedDynamicTags);
        break;
      case 4:
        this.delRoleUserList(this.selectedDynamicTags);
        break;
      case 5:
        this.remainUserList(this.selectedDynamicTags,1);
        // 提醒人员设定
        break;
      case 6:
        this.remainUserList(this.selectedDynamicTags,2);
      // 禁止报修人员设定
        break;
    }
  }
  // 添加 部门人员列表
  private getNotInDeptUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.dept_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getNotInDeptUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 添加 部门人员
  private setDeptUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      department_str: this.paramsStr,
      user_str: userStr
    };
    setUserDept(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }
  // 删除 部门人员
  private delDeptUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      dept_id: this.paramsStr,
      user_str: userStr
    };
    batchDelDeptUser(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }
  // 删除 部门人员 列表
  private getDeptUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.dept_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getDeptUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 删除 角色人员列表
  private getRoleUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.company_role_id = this.paramsStr;
    params.name = this.listQuery.name;
    params.page = this.page;
    getRoleUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }

  // 设置超时提醒人员列表
  private authUserList(type:any) {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    //如果是提醒人员拉取客户 role_type 1 客服 如果是限制报修 role_type 4为工程师加客服
    params.role_type = type == 1 ? 1 : 4 ;
    params.name = this.listQuery.name;
    params.page = this.page;
    //现有的方案要保存列表上已选择的 但现有组件有分页及选中表格会清楚之前选择数据 所以设置为100条数据
    params.size = 100;
    authUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
        this.getSelectauthUserList(type);
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }

  // 设置超时提醒人员列表
  private getSelectauthUserList(type:any) {
    let params: any = {};
    params.type=type;
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    timeoutUserLists(params)
      .then(res => {
        if (res.data) {
          var tempList:any = [];
          var timeoutUserList:any = [];
          res.data.list.map((temp: any) => {
            //超时的人员可能不在权限人员中 所以不能过滤
            let timeoutUser = {id:temp.user_id,name:temp.user_name,remark:'有变动'}
            this.tableList.map((t:any) => {
              if (t.id === temp.user_id) {
                tempList.push(t);
                timeoutUser.remark = ''
              }
            });
            timeoutUserList.push(timeoutUser)
          });
          this.toggleSelection(tempList);
          this.selectedDynamicTags =timeoutUserList ;
          console.log(this.selectedDynamicTags)
          // this.selectedDynamicTags.map((temp : any) => {
          // });
     
        } else {
        //   this.tableList = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }

  // 添加 部门人员列表
  private getNoRoleUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.company_role_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getNoRoleUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 添加 角色人员
  private setRoleUserList(roleData:any) {
    let _this = this;
    var userStr = '';
    for (var user of roleData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_role_id: this.paramsStr,
      user_str: userStr,
      vip_level: (UserModule.company as any).vip_level
    };
    setUserRole(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }
  // 删除 角色人员
  private delRoleUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).uid + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_role_id: this.paramsStr,
      user_str: userStr
    };
    batchDelRoleUser(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }

  private remainUserList(val:any,type:any) {
    let _this = this;
    var t :any = [];
    val.map((temp:any) => {
      var b:any = {};
      b.user_id = temp.id;
      b.user_name = temp.name;
      b.type = type;
      t.push(b);
    });
    const params = {
      type: type,
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      timeout_user: JSON.stringify(t)
    };
    timeoutUser(params)
      .then(res => {
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }

  private handleSelectionChange(val: []) {
    this.selectedDynamicTags = val;
  }
  private closeTagHandle(val: any) {
    let _this = this;
    _this.selectedDynamicTags.splice(_this.selectedDynamicTags.indexOf(val), 1);
    for (let index = 0; index < _this.tableList.length; index++) {
      if ((_this.tableList[index] as any).id === (val as any).id) {
        _this.toggleSelection([_this.tableList[index]]);
      }
    }
  }
  private toggleSelection(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        (this.$refs.tableAll as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.tableAll as any).clearSelection();
    }
  }
  close() {
    this.page = 1;
    this.$emit('close', false);
  }
}
